import { Component } from '@angular/core';

@Component({
    selector: 'error-notauthorized',
    templateUrl: './notauthorized.component.html',
    styles: []
})
export class NotAuthorizedComponent {
    constructor() { }
}